import dynamic from 'next/dynamic'

export const PolicyCategory = dynamic(() => import('./policy-category'))
